module.exports = __webpack_public_path__ + "static/img/C (10).a74eb938.png";